/**
 * @copyright (C) 2025, rsupport. All rights reserved
 *
 * @license
 * This software and/or source code may be used, copied and/or disseminated only
 * with the written permission of rsupport, or in accordance with the terms
 * and conditions stipulated in the agreement/contract under which the software
 * and/or source code has been supplied by rsupport or its affiliates.
 * Unauthorized use, copying, or dissemination of this file, via any medium, is
 * strictly prohibited, and will constitute an infringement of copyright.
 *
 * @author
 * Jinhyoung Jang (jangjh@rsupport.com)
 *
 * @description
 *
 * @created at 2025-01-31 12:14:52
 **/

import { useEffect, useState } from "react";
import { interval, timer } from "rxjs";
import styled from "@emotion/styled";
import { Maybe, Loader } from "@/components";
import { GlobalStyles } from "@/styles";
import { SerializedStyles } from "@emotion/react";
import { LoaderProps } from "@/components/Loader/Loader.tsx";

type FullScreenLoaderProps = Partial<{
	default_styles: SerializedStyles;
	type: LoaderProps["type"];
	color: LoaderProps["color"];
	message: string;
}>;

export default function FullScreenLoader(props: FullScreenLoaderProps) {
	const [count_dot, set_count_dot] = useState<string>("");
	const [is_show, set_is_show] = useState<boolean>(false);

	useEffect(() => {
		timer(500).subscribe(() => {
			set_is_show(true);
		});
	}, []);

	useEffect(() => {
		if (!is_show) return;
		const id = interval(100).subscribe(() => {
			set_count_dot((value) => value + ".");
		});
		return () => {
			id.unsubscribe();
		};
	}, [is_show]);

	useEffect(() => {
		if (count_dot.length > 3) {
			set_count_dot("");
		}
	}, [count_dot]);

	return (
		<Container>
			<Maybe test={is_show}>
				{props.default_styles && <GlobalStyles default_styles={props.default_styles} />}
				<Loader type={props.type ?? "clip"} color={props.color ?? "#fff"} />
				<h3>{`${props.message ?? "Loading"}${count_dot}`}</h3>
			</Maybe>
		</Container>
	);
}

const Container = styled.div`
	display: flex;
	flex: 1;
	justify-content: center;
	align-items: center;
	min-height: 100vh;

	h3 {
		display: flex;
		justify-content: flex-start;
		width: 100px;
		margin-left: 1rem;
	}
`;
